import * as z from "zod";

export const PARTNER_TYPES = ["individual", "app", "agency"] as const;
export const PARTNER_STATUSES = ["active", "paused", "terminated"] as const;

export const PartnerSummarySchema = z.object({
  id: z.string(),
  email: z.email(),
  name: z.string(),
  referralCode: z.string(),
  profileImageUrl: z.string().url().nullable(),
  partnerType: z.enum(PARTNER_TYPES),
  status: z.enum(PARTNER_STATUSES),
});

export type PartnerSummary = z.infer<typeof PartnerSummarySchema>;
